class DataStructureModifierHelper {
  static errorMessagesToStringArray(errors) {
    if (typeof errors === "string" && errors !== "") {
      return [errors];
    } else if (errors.errors) {
      return errors.errors.map((err) => err.message);
    } else if (
      (typeof errors === "object" && !Array.isArray(errors)) ||
      errors === ""
    ) {
      return ["Er ging wat fout"];
    } else {
      return errors;
    }
  }
}

export default DataStructureModifierHelper;



// WEBPACK FOOTER //
// ./src/helpers/DataStructureModifierHelper.js